import React from 'react';
import { proofStats } from '../../data/websites';
export function ProofStrip() {
  return <section aria-label="At a glance" className="bg-brand-black px-[clamp(1rem,4vw,6rem)] py-6" data-id="element-1009" data-mp="2asykz7cel00d">
      <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4" data-id="element-1010" data-mp="1vvnzd561qdqx">
        {proofStats.map(stat => <li key={stat.label} className="flex items-center gap-3" data-id="element-1011" data-mp="20tg1st4bhi9d">
            <stat.icon className="h-5 w-5 flex-shrink-0 text-brand-red" aria-hidden="true" data-id="element-1012" data-mp="1n2ui5271h4af" />
            <span className="text-[clamp(0.9375rem,1vw,1.125rem)] font-semibold text-white" data-id="element-1013" data-mp="1rtkl68rzsv1y">{stat.label}</span>
          </li>)}
      </ul>
    </section>;
}